import { Box,
    DialogTitle as MuiDialogTitle, IconButton,
    TextField as MuiTextField,
    Typography } from '@mui/material';
import { styled } from '@mui/system';

import { colors } from '../../../../theme';

export const dialogPaperProps = {
    style: {
        backgroundColor: colors.darkBlue,
        color: colors.white,
        padding: '20px',
        borderRadius: '8px',
        margin: '16px',
        maxWidth: '600px'
    }
};

export const DialogTitle = styled(MuiDialogTitle)({
    textAlign: 'center',
    fontWeight: 'bold'
});

export const QuestReviewContainer = styled(Box)({
    marginTop: '20px'
});

export const QuestReviewTextField = styled(MuiTextField)({
    '& .MuiOutlinedInput-root': {
        backgroundColor: colors.darkBlue,
        borderRadius: '8px',
        color: colors.white,
        fontSize: '14px',
        '& fieldset': {
            borderColor: colors.darkGray
        },
        '&:hover fieldset': {
            borderColor: colors.hitGray
        },
        '&.Mui-focused fieldset': {
            borderColor: colors.lightningYellow
        }
    },
    '& .MuiInputBase-input': {
        color: colors.white,
        fontSize: '14px'
    },
    '& .MuiInputBase-input::placeholder': {
        color: colors.lightGray,
        opacity: 0.8
    }
});

export const QuestReviewButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginTop: '15px'
});

export const QuestReviewDialogContent = styled(Box)({
    paddingTop: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
});

export const QuestReviewDialogDescription = styled(Typography)({
    color: colors.white,
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '10px',
    textAlign: 'center',
    width: '100%',
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto'
});

export const QuestReviewDialogButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginTop: '20px',
    width: '100%',
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto'
});

export const QuestReviewDialogCloseButton = styled(IconButton)({
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: colors.white,
    '&:hover': {
        backgroundColor: colors.darkGray
    }
});
